import { Typography, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './CheckDetailTitle'
import TimelineDotLine from '../components/TimelineDotLine'
import CheckRiskStatus from '../components/CheckRiskStatus'

const CheckProtestos = ({ protestosCheck }) => {
  const { t } = useTranslation(['common', 'messages'])
  const details = protestosCheck?.checkDetails
  const hasChecks =protestosCheck.found && details && typeof details === 'object'
  const checkLength = hasChecks ? 1 : 0

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{t('common:protestos')}</Typography>
        <CheckRiskStatus checkLength={checkLength} hasChecks={hasChecks} />
      </Paper>

      <CheckDetailTitle
        email={protestosCheck?.email}
        status={protestosCheck?.status}
        createdAt={protestosCheck?.createdAt}
        updatedAt={protestosCheck?.updatedAt}
      />

      {hasChecks && (
        <TimelineDotLine>
          <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
            <div className="c-detail-grid">
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:origin')}</Typography>
                <Typography variant="subtitle3">{details?.Origin ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:inputParameters')}</Typography>
                <Typography variant="subtitle3">{details?.InputParameters ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:queryDate')}</Typography>
                <Typography variant="subtitle3">{details?.QueryDate ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:totalProtests')}</Typography>
                <Typography variant="subtitle3">{details?.TotalProtests ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:totalProtestsValue')}</Typography>
                <Typography variant="subtitle3">{details?.TotalProtestsValue ?? '---'}</Typography>
              </div>
            </div>
          </Paper>
        </TimelineDotLine>
      )}
    </>
  )
}

export default CheckProtestos
